import React from 'react';
import { UserDashboardLayout } from './UserDashboardLayout';
import { AttendanceDashboard } from '../attendance';

const UserAttendance: React.FC = () => {
  return (
    <UserDashboardLayout>
      <div className="p-6">
        <AttendanceDashboard />
      </div>
    </UserDashboardLayout>
  );
};

export default UserAttendance;
